import React, { useState, useEffect } from 'react';
import '../styles/LoadingIndicator.css';

const styles = [
  'style-base',
  'style-icicle',
  'style-flame',
  'style-steel',
  'style-magical',
  'style-water',
  'style-retro',
  'style-monster',
  'style-glitch'
];

// Fisher-Yates shuffle to randomize the style order
const shuffleArray = (array) => {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
};

const LoadingIndicator = () => {
  const [styleIndex, setStyleIndex] = useState(0);
  const [shuffledStyles, setShuffledStyles] = useState([]);

  // Shuffle styles on mount
  useEffect(() => {
    setShuffledStyles(shuffleArray(styles));
  }, []);

  // Set up style-changing interval once styles are shuffled
  useEffect(() => {
    if (shuffledStyles.length === 0) return;

    const styleIntervalId = setInterval(() => {
      setStyleIndex((prevIndex) => (prevIndex + 1) % shuffledStyles.length);
    }, 200); // Change style every 200ms

    return () => clearInterval(styleIntervalId);
  }, [shuffledStyles]);

  const currentStyle = shuffledStyles[styleIndex] || 'style-base';

  return (
    <div className="loading-indicator-container">
      <div className={`komok-logo ${currentStyle}`}>
        KOMO<span className="mirrored-k">K</span>
      </div>
    </div>
  );
};

export default LoadingIndicator;
